/* eslint-disable key-spacing */

interface Api {
  [apiKey: string]: {
    /*
			endpoint of the api
		*/
    endpoint: string;

    /*
			http method of the api
		*/
    method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" | "OPTION";

    /*
			should we add authentication token to the api ?
			value is considered as false if omitted
		*/
    escapeAuthToken?: boolean;
  };
}

export const api: Api = {
  //////////////////UPDATED ROUTES//////////////////////
  //PATIENT
  signUp: { endpoint: "/auth/loginrequest", method: "POST" },
  confirmationCode: { endpoint: "/auth/accesstoken", method: "POST" },
  createProfile: {
    endpoint: "/profile",
    method: "POST",
  },
  updateProfile: {
    endpoint: "/profile/{id}",
    method: "PATCH",
  },
  userProfile: { endpoint: "/profile", method: "GET" },

  //HEALTH WORKER
  healthWorkers: { endpoint: "/health-worker/search", method: "GET" },
  HWProfileByID: {
    endpoint: "/health-worker-profiles/{HWProfileID}",
    method: "GET",
  },
  HWProfile: { endpoint: "/health-worker/slug", method: "GET" },
  getVideoCallSetting: { endpoint: "/appointmentId/{id}", method: "GET" },
  reserveAppointment: {
    endpoint: "/appointment/book-appointment",
    method: "POST",
  },

  downloadAppointment: {
    endpoint: "/appointment/patient-appointments/appointmentId/{id}",
    method: "GET",
  },
  appointmentDetail: {
    endpoint: "/appointment/patient-appointments/appointmentId/{id}",
    method: "GET",
  },
  appointmentsList: {
    endpoint: "/appointment/patient-appointments/patientId/{id}",
    method: "GET",
  },
  deleteAppointment: {
    endpoint: "/appointment/patient-appointments/appointmentId/{id}",
    method: "DELETE",
  },
  uploadDocument: {
    endpoint: "/patient-files",
    method: "POST",
  },
  getFreeTimes: {
    endpoint: "/services/free-slots",
    method: "GET",
  },
  //APPOINTMENTS
  getMedicalDocumentByApptId: {
    endpoint: "/appointment/patient-appointments/appointmentId/{id}",
    method: "GET",
  },
  getFileByFileId: {
    endpoint: "/file/{id}",
    method: "GET",
  },
  deleteMedicalDocument: {
    endpoint: "/appointment/patient-appointments/appointmentId/{id}",
    method: "DELETE",
  },

  downloadMedicalDocument: {
    endpoint: "/file/{id}",
    method: "GET",
  },

  //GENERAL
  getCities: { endpoint: "/locations/city", method: "GET" },
  getSpecialties: { endpoint: "/specialties", method: "GET" },
  payAppointment: { endpoint: "/payments/{id}", method: "POST" },

  //HEALTH PROVIDER
  getTermsAndConditions: { endpoint: "/health-provider/terms", method: "GET" },

  ////////////////////////////OLD ROUTES//////////////////////

  createSchedule: { endpoint: "/bulkfreetime", method: "POST" },

  //////////////////////////////////DONT NEED MIGRATION NOW//////////////////////////////////////
  oneTimeLogin: { endpoint: "/health-workers/onetimelogin", method: "POST" },
  todayAppointment: {
    endpoint: "/health-providers/{HPID}/appointments/today",
    method: "GET",
  },
  HWData: { endpoint: "/me", method: "GET" },
  HPMedicalTeam: {
    endpoint: "/medical-team/health-provider-profiles",
    method: "GET",
  },
  HWFreeTime: {
    endpoint: "/health-workers/{healthWorkerId}/free-times/",
    method: "GET",
  },
  sendSMS: {
    endpoint: "/patients/{userId}/appointments/{apptId}/sendSMS",
    method: "GET",
  },
  HPProfile: { endpoint: "/health-provider-profiles", method: "GET" },
  getFAQ: { endpoint: "/faq", method: "GET" },

  apptChangeStatus: {
    endpoint:
      "/health-providers/{HPID}/patients/{patientID}/appointments/{apptID}/status",
    method: "POST",
  },
  addService: { endpoint: "/health-providers/{HPID}/services", method: "PUT" },
  getServices: {
    endpoint: "/health-providers/{HPID}/services/{HWID}",
    method: "GET",
  },
  getServicesSchedule: {
    endpoint: "/health-providers/{HPID}/service-schedules",
    method: "GET",
  },
  deleteSchedule: {
    endpoint: "/health-providers/{HPID}/service-schedules",
    method: "DELETE",
  },
  deleteService: {
    endpoint: "/health-providers/{HPID}/services/{serviceID}",
    method: "DELETE",
  },
  updateService: {
    endpoint: "/health-providers/{HPID}/services/{serviceID}",
    method: "POST",
  },
  getHPServices: { endpoint: "/health-workers/{HWId}/services", method: "GET" },
};
